type Props = React.ComponentProps<'svg'>

function CloseIcon(props: Props): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 30 30"
      {...props}
    >
      <g filter="url(#filter0_d_86_136)">
        <path
          fill="currentColor"
          d="M22.99 2.04 15.03 10 7.04 2 2 7.04l8 7.99L2.03 23l4.99 4.99 7.97-7.97L22.96 28 28 22.96l-7.98-7.97 7.96-7.96-4.99-4.99Z"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_86_136"
          width="26"
          height="28"
          x="2"
          y="2"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_86_136"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_86_136"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default CloseIcon
